export default __webpack_public_path__ + "files/3bce5e90cd1abe34c512a66d95328d8c.jpg";